import MicroModal from "micromodal";
import { getScrollBarWidth } from "@/scripts/helpers/library";
import select2 from "select2";

const execYoutubeCommand = (frame, command) => {
  if (frame.contentWindow === null) {
    return;
  }

  frame.contentWindow.postMessage(
    window.JSON.stringify({ event: "command", func: command }),
    "https://www.youtube.com"
  );
};

const modalHandler = (modal, command) => {
  const iframes = modal.querySelectorAll("iframe");

  [].forEach.call(iframes, frame => {
    execYoutubeCommand(frame, command);
  });
};

const hideCustomSelect = () => {
  const selectFieldModal = $(".modal-employees");
  const selectFieldModalOpen = $(".select2-container--open");

  if (selectFieldModalOpen.length > 0) {
    selectFieldModal.select2("close");
  }
};

export default () => {
  const lockClassName = "scroll-locked";
  const animationDuration = 250;

  MicroModal.init({
    awaitCloseAnimation: true,
    disableFocus: true,
    onShow: modal => {
      modalHandler(modal, "playVideo");
      $("body")
        .addClass(lockClassName)
        .css("padding-right", getScrollBarWidth());
    },
    onClose: modal => {
      hideCustomSelect();
      modalHandler(modal, "pauseVideo");
      setTimeout(() => {
        $("body")
          .removeClass(lockClassName)
          .css("padding-right", "");
      }, animationDuration);
    }
  });
};
